export default "__VITE_ASSET__CJIMF2Jl__"